<template>
  <div style="display:flex" class="mb-6">
    <grid-translator-box :grid_translator="grid_translator"></grid-translator-box>
    <img :src="require('@/assets/images/arrow.jpg')" style="height:120px;margin-top:45px;margin-left:40px;margin-right:40px"/>
    <grid-translator-box :grid_translator="grid_translator" :allow_modification="true"></grid-translator-box>
  </div>
</template>

<script>
import GridTranslatorBox from './GridTranslatorBox.vue';
export default {
  components: { 
    GridTranslatorBox, 
  },
  name: "show-grid-translator",
  props: {
    grid_translator: {
      type: Object,
    },
  },
  data() {
    return {
      
    };
  },
};
</script>
<style scoped>
.grid-rows {
  display: flex;
}
.grid-columns {
  border: 1px solid black;
}
</style>